import React, { Component }  from 'react'
import { Icon, Modal, Button } from 'semantic-ui-react'

class SubjectsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
      description: '',
      subjectCategory: '',
      showModal: false,
      subjectId: '',
    };
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  componentDidMount() {
    this.setState({
      name: this.props.subject.name,
      code: this.props.subject.code,
      description: this.props.subject.description,
      subjectCategory: this.props.subject.subjectCategory,
      subjectId: this.props.subject.subjectId
    })
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      name: newProps.subject.name,
      code: newProps.subject.code,
      description: newProps.subject.description,
      subjectCategory: newProps.subject.subjectCategory,
      subjectId: newProps.subject.subjectId
    })
  }

  render() {

    return (
      <Modal
        trigger={
          <Button icon size='tiny' onClick={this.openModal}>
            <Icon name='eye' />
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>{this.state.name} ({this.state.code}) <span className='subject-category'>{ this.state.subjectCategory === '' ? '--' : this.state.subjectCategory}</span></Modal.Header>
        <Modal.Content>
          {this.state.description}
        </Modal.Content>
        <Modal.Actions>

        </Modal.Actions>
      </Modal>
    )
  }
};

export default SubjectsView;
